"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _core = require("../core");

var _utils = require("../utils");

var _excluded = ["color"],
    _excluded2 = ["color"],
    _excluded3 = ["color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _utils.createStylesHook)()(function (theme) {
  var _theme$typography = theme.typography,
      _theme$typography$bod = _theme$typography.body1,
      colorBody1 = _theme$typography$bod.color,
      body1Typography = _objectWithoutProperties(_theme$typography$bod, _excluded),
      _theme$typography$bod2 = _theme$typography.body2,
      colorBody2 = _theme$typography$bod2.color,
      body2Typography = _objectWithoutProperties(_theme$typography$bod2, _excluded2),
      _theme$typography$cap = _theme$typography.caption,
      colorCaption = _theme$typography$cap.color,
      captionTypography = _objectWithoutProperties(_theme$typography$cap, _excluded3);

  return {
    root: _objectSpread(_defineProperty({
      width: 'unset',
      minHeight: '3rem',
      '&:hover': {
        backgroundColor: theme.palette.primary.lightest
      }
    }, theme.breakpoints.up('sm'), {
      minHeight: '3rem'
    }), body1Typography),
    gap: {
      margin: theme.spacing(0.5),
      borderRadius: theme.shape.borderRadius / 2
    },
    extraSmall: _objectSpread({
      minHeight: '1.5rem',
      paddingTop: theme.spacing(0.25),
      paddingBottom: theme.spacing(0.25)
    }, captionTypography),
    small: _objectSpread({
      minHeight: '2rem',
      paddingTop: theme.spacing(0.25),
      paddingBottom: theme.spacing(0.25)
    }, body2Typography),
    large: {
      minHeight: '3.5rem'
    },
    extraLarge: {
      minHeight: '4rem'
    },
    selected: {
      '$root&': {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.altLight,
        '&:hover': {
          backgroundColor: theme.palette.primary.lightest
        }
      }
    },
    selectedHighlight: {
      '$root&': {
        paddingLeft: theme.spacing(2) - 4,
        borderLeft: "4px solid ".concat(theme.palette.primary.main)
      }
    },
    gutters: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  };
}, {
  name: (0, _core.rochePrefix)('ListItem')
});
exports.useStyles = useStyles;